import classNames from 'classnames';
import * as React from 'react';
import './SvgLoading.scss';

export interface SvgLoadingProps extends React.HTMLAttributes<HTMLDivElement> {
    className?: string;
    style?: React.CSSProperties;
    size?: 'large' | 'normal' | 'small';
    inline?: boolean;
    'data-cy'?: string;
}

export const SvgLoading: React.FC<SvgLoadingProps> = React.memo(
    ({ className = '', inline = false, size = 'normal', ...props }) => (
        <div
            className={classNames(
                'svg-loading',
                {
                    'svg-loading-inline': inline,
                    'svg-loading-large': size === 'large',
                    'svg-loading-small': size === 'small',
                },
                className,
            )}
            {...props}
        />
    ),
);
SvgLoading.displayName = 'SvgLoading';
